import { jsx as t } from "react/jsx-runtime";
import r from "./roche-lead-text.module.scss.js";
const a = ({ children: s, lead: e }) => e != null ? /* @__PURE__ */ t("p", { className: r["lead-text"], children: e }) : /* @__PURE__ */ t("div", { className: r["lead-text"], children: s });
export {
  a as RocheUILeadText
};
